export default {
      id: "ic_info_circle_green-usage",
      viewBox: "0 0 40 40",
      url: "/" + "images/icons.3.109.2.svg#ic_info_circle_green-usage",
      toString: function () {
        return this.url;
      }
    }